import { Grid, Typography, Select, Checkbox, MenuItem, Box } from '@material-ui/core';
import { Check, ArrowDropDown } from '@material-ui/icons';
import React, { useState } from 'react';
import { useCampfireTheme } from '../../../../../../../theme/useCampfireTheme';
import { BorderSelectInput, useFilterStyles } from '../../../../../../../common/filter-fields/FilterClasses';
import { statusFilters, IncomingVolunteersSelectFieldProps, DEFAULT_STATUS_FILTER } from '../filters';

export const StatusSelectField = ({ selectedFilters, setSelectedFilters }: IncomingVolunteersSelectFieldProps) => {
  const [popoverOpen, setPopoverOpen] = useState<boolean>(false);
  const { theme } = useCampfireTheme();
  const classes = useFilterStyles(theme);
  const isStatusSelected = (value: string) => selectedFilters.selectedStatusFilter === value;
  const isActiveFilter = selectedFilters.selectedStatusFilter !== DEFAULT_STATUS_FILTER;

  const handleStatusChange = (event: EventTarget & any) =>
    setSelectedFilters({
      ...selectedFilters,
      selectedStatusFilter: event.target.value,
    });

  return (
    <Grid item className={classes.subheaderGridItem}>
      <Select
        displayEmpty
        open={popoverOpen}
        onOpen={() => setPopoverOpen(true)}
        onClose={() => setPopoverOpen(false)}
        input={<BorderSelectInput status={isActiveFilter ? 'active' : undefined} />}
        IconComponent={() => (
          <Box display='flex' alignItems='center' onClick={() => setPopoverOpen(true)} style={{ cursor: 'pointer' }}>
            <ArrowDropDown style={{ fill: isActiveFilter ? theme.palette.primary.main : 'rgba(0,0,0, 0.54)' }} />
          </Box>
        )}
        renderValue={() => selectedFilters.selectedStatusFilter}
        onChange={handleStatusChange}
        value={selectedFilters.selectedStatusFilter}
      >
        {statusFilters.map((filter) => (
          <MenuItem key={filter} value={filter} className={classes.menuItem}>
            <Typography
              variant='body2'
              style={isStatusSelected(filter) ? { fontWeight: 600 } : { fontWeight: 'normal' }}
            >
              {filter}
            </Typography>
            <Checkbox
              checked={isStatusSelected(filter)}
              className={classes.checkBoxSelectField}
              checkedIcon={<Check color='primary' width={12} />}
              icon={<span className={classes.icon} />}
              disableRipple
            />
          </MenuItem>
        ))}
      </Select>
    </Grid>
  );
};
